// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"a95ddcae","119":"bb0d4e28","223":"0d41a94a","356":"93306879","442":"4d004e2c","464":"ba3c9278","488":"881a20a4","986":"e9ee7ff3"}[chunkId] + ".chunk.js";
};